import React from "react";
import "./header.css";
import HeaderButtons from "./HeaderButtons";
import HeaderSocials from "./HeaderSocials";
import Me from "../../assets/me-bg-laugh.jpg";

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>David Pocsai</h1>
        <h5 className="text-light">Fullstack Developer</h5>
        <HeaderButtons />
        <HeaderSocials />
        <div className="me">
          <img src={Me} alt="Me" />
        </div>
        <a href="#about" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
